import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import axios from "axios";
import apiClient from "../../service/Axios";

const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState();
  //onsubmit function
  const onSubmit = async (data) => {
    const { email, password } = data;
    // console.log(email, password);
    // `${process.env.REACT_APP_API}`;
    axios
      .post(`${process.env.REACT_APP_AUTHENTICATION_API}/user/login/`, data)
      .then((res) => {
        // console.log("res", JSON.stringify(res?.data));
        // console.log("res", res?.data?.token);
        localStorage.setItem("usersInfo", JSON.stringify(res?.data));
        localStorage.setItem(
          "usersAccessTocken",
          JSON.stringify(res?.data?.token?.access)
        );
        toast.success("user login successfully");
        res.status == 200 && navigate("/");
        // apiClient.get("/user/profile/").then((res) => {
        //   localStorage.setItem("usersData", JSON.stringify(res?.data));
        //   // console.log("profile", res);
        //   console.log(
        //     "first",
        //     localStorage.setItem("usersData", JSON.stringify(res?.data))
        //   );
        // });
      })
      .catch((err) => setError(err.response.data.errors.non_field_errors[0]));
  };

  return (
    <div className="flex min-h-full flex-col justify-center px-6 py-14 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <div className="flex justify-center items-center">
          <img src={logo} alt="logo" width={100} />
        </div>
        <p className="text-center mt-3 text-xl">
          Sign in to DE<span className="text-[#1068BF]">VT</span>ools
        </p>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm p-6 rounded-[7px] border border-gray-200 bg-gray-100">
        <form
          className="space-y-6"
          action="#"
          method="POST"
          onSubmit={handleSubmit(onSubmit)}>
          <div className="form-control">
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900 mb-0.5">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="input input-bordered w-full rounded-[5px] h-10"
              autoComplete="email"
              {...register("email", {
                required: true,
                pattern: /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/,
              })}
            />
            {errors.email && (
              <span className="text-red-500 text-base mt-1">
                Please enter a valid email address.
              </span>
            )}
          </div>
          <div className="form-control">
            <div className="flex justify-between items-center">
              <label
                htmlFor="password"
                className="block text-sm font-medium leading-6 text-gray-900 mb-0.5">
                Password
              </label>{" "}
              <p className="mt-0.5 flex justify-end mb-0.5">
                <Link
                  to=""
                  className="font-normal text-[14px] text-[#1068BF] hover:text-[#5297dc]">
                  Forgot your password?
                </Link>
              </p>
            </div>
            <div className="relative">
              <input
                type={`${show ? "text" : "password"}`}
                id="password"
                name="password"
                className="input input-bordered w-full rounded-[5px] h-10"
                autoComplete="new-password"
                {...register("password", { required: true, minLength: 4 })}
              />
              {errors.password && (
                <span className="text-red-500 text-base mt-1">
                  Please enter a password.
                </span>
              )}
              {error ? (
                <span className="text-red-500 text-base mt-1">{error}</span>
              ) : (
                ""
              )}
              {show ? (
                <AiOutlineEye
                  className="absolute top-3 right-3 text-xl text-gray-600 cursor-pointer"
                  onClick={() => setShow(!show)}
                />
              ) : (
                <AiOutlineEyeInvisible
                  className="absolute top-3 text-xl right-3 text-gray-400 cursor-pointer"
                  onClick={() => setShow(!show)}
                />
              )}
            </div>
          </div>
          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-[5px] bg-[#161B22] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[#2a5784]">
              Sign in
            </button>
          </div>
        </form>
      </div>
      <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-sm p-6 rounded-[7px] border border-gray-200 bg-gray-100">
        <p className="text-center text-sm text-gray-800">
          New to DE<span className="text-[#1068BF]">VT</span>ools?
          <Link
            to="/register"
            className="font-normal leading-6 text-[#1068BF] hover:text-[#5297dc] ml-1">
            Create an account
          </Link>
        </p>
      </div>
      <div className="flex justify-center items-center gap-8 mt-32 text-[15px] text-gray-600">
        <p>Terms</p>
        <p>Privacy</p>
        <p>Docs</p>
        <p>
          Contact DE<span className="text-[#1068BF]">VT</span>ools Support
        </p>
        <p>Manage cookies</p>
        <p>Do not share my personal information</p>
      </div>
    </div>
  );
};

export default Login;
